import React, { useEffect, useState } from 'react';
import useKitchenItemRequestContext from 'contexts/kitchen/item-request.context/context';
import { apiService } from 'services/base.service';
import { handleApiError } from 'utils/functions';
import RequestItemsList from 'components/base/request-items-list';
import UpdateKitchenMenu from 'pages/prep-team/kitchen-request/update-kitchen-request/update-kitchen-menu';
import { PrepRequestType } from 'models/prep-request.model';
import RequestListLayout from 'components/base/request-list-layout';

type Props = {
  onSendItems: (itemId: string) => void;
};

const BrandChefRequestList: React.FC<Props> = ({ onSendItems }) => {
  const { itemRequestToEdit } = useKitchenItemRequestContext();
  const [loading, setLoading] = useState(false);
  const [itemRequestToUpdate, setItemRequestToUpdate] = useState<PrepRequestType>(
    {} as PrepRequestType
  );
  const getRequestItems = async () => {
    if (!itemRequestToEdit.id) return;
    setLoading(true);
    try {
      const res = await apiService.get(`prep-kitchen-request/${itemRequestToEdit.id}`, {
        version: 'v2'
      });
      setItemRequestToUpdate(res.data.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRequestItems();
  }, [itemRequestToEdit.id]);

  const items = itemRequestToUpdate?.items || [];
  const requestStatus = itemRequestToEdit.status;

  return (
    <RequestListLayout showHeader={false}>
      <RequestItemsList
        items={items.map((item) => ({
          ...item,
          actionsMenu: (
            <UpdateKitchenMenu status={item.status} itemId={item.id} onSendItems={onSendItems} />
          )
        }))}
        loading={loading}
        requestStatus={requestStatus}
        showDetailsToggle
      />
    </RequestListLayout>
  );
};

export default BrandChefRequestList;
